import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRoute from 'constants/apiRouting'
import {
  FETCH_WEATHER_DATA,
  SUCCESS_WEATHER_DATA,
  FAILURE_WEATHER_DATA,
  FETCH_SENSORS_DATA,
  SUCCESS_SENSORS_DATA,
  FAILURE_SENSORS_DATA,
} from './reducer'

function* fetchWeatherData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.WEATHER_DIGEST, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_WEATHER_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_WEATHER_DATA })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchSensorsData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SENSORS_DIGEST, action.payload),
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({ type: SUCCESS_SENSORS_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SENSORS_DATA })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* slaEnvironmentSaga() {
  yield takeLatest(FETCH_WEATHER_DATA, fetchWeatherData)
  yield takeLatest(FETCH_SENSORS_DATA, fetchSensorsData)
}

export default slaEnvironmentSaga
